import {Dialog, Transition} from '@headlessui/react';
import React, {Fragment, PropsWithChildren} from 'react';
import {useTranslation} from 'next-i18next';
import {useRouter} from 'next/router';
import {getDirection} from '@/lib/constants';
import cn from 'classnames';
import {nunito} from 'public/assets/fonts/fonts';
interface Props {
    open?: boolean;
    onClose: () => void;
    className?: string;
    topRightElement?: React.JSX.Element;
}

export default function Modal({open, onClose, children, className, topRightElement}: PropsWithChildren<Props>) {
    const {t} = useTranslation('common');

    const {locale} = useRouter();
    const dir = getDirection(locale);
    return (
        <Transition show={open} as={Fragment}>
            <Dialog
                as="div"
                className={`${nunito.variable} fixed inset-0 z-50 overflow-y-auto font-body`}
                static
                open={open}
                onClose={onClose}
                dir={dir}>
                <div className={cn('min-h-full text-center md:p-5', className)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <div className="fixed inset-0 h-full w-full bg-overlay-gray" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="inline-block h-screen align-middle" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95">
                        <Dialog.Panel className="min-w-content relative inline-block max-w-full align-middle transition-all ltr:text-left rtl:text-right">
                            <div className="absolute top-4 z-60 ltr:right-4 rtl:left-4">{topRightElement}</div>
                            {children}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
